module.exports = __webpack_public_path__ + "media/DeluxNargila.ae270c61.webm";